export default __webpack_public_path__ + "static/media/dropdown-selecte-ic.d70fb7e3.svg";